import classNames from "classnames";
import styles from "./SettingsSection.module.scss";

function SectionLabel({ children }: { children: string }) {
  return <h3 className={styles.sectionLabel}>{children}</h3>;
}

function SectionDescription({ children }: { children: React.ReactNode }) {
  return typeof children === "string" ? (
    <p className={styles.sectionDescription}>{children}</p>
  ) : (
    <div className={styles.sectionDescription}>{children}</div>
  );
}

function SettingsSection({
  label,
  description,
  children,
  orientation = "horizontal",
}: {
  label: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  orientation?: "horizontal" | "vertical";
}) {
  return (
    <div
      className={classNames(styles.section, {
        [styles.vertical]: orientation === "vertical",
      })}
    >
      <div className={styles.sectionLeft}>
        <SectionLabel>{label}</SectionLabel>
        {description && <SectionDescription>{description}</SectionDescription>}
      </div>
      {children}
      {/* <div>{children}</div> */}
      {/* <div className={styles.sectionRight}>{children}</div> */}
    </div>
  );
}

export default SettingsSection;
